import Vue from "vue"

const path = "qr"

export default {
    refresh(data) {
        console.log('data', data);
        if (data.data.platform === 'paciolan') {
            return Vue.prototype.$http.post(`${path}/paciolan/scrape`, data)
        }
        
        if (data.data.platform === 'seatgeek' && data.data.request_type === 'GENERATE_QR_ASYNC') {
            return Vue.prototype.$http.post(`${path}/seatgeek/scrape`, data)
        }
        
        if (data.data.platform === 'seatgeek' && data.data.request_type === 'SEATGEEK_OFFICIAL_API') {
            return Vue.prototype.$http.post(`${path}/seatgeek/scrape/official`, data)
        }
        
        if (data.data.platform === 'ticketmaster' && data.data.request_type === 'TM_AM_SCRAPE') {
            return Vue.prototype.$http.post(`${path}/ticketmaster/am-scrape`, data)
        }
        
        return Vue.prototype.$http.post(`${path}/generate-async`,  data)
    },
    history(filterArray, isAdmin = false) {
        const options = { page: 1, items_per_page: 50, order_by: [], }
        const filter = filterArray ?? []
        const all = isAdmin
        return Vue.prototype.$http.post(`${path}/ticket-request/list`, { options, filter, all })
    },
    response(id, data = null) {
        return Vue.prototype.$http.get(`${path}/ticket-request/response/${id}`, { data })
    },
    credits(data) {
        return Vue.prototype.$http.post(`refresh/credits`, { data })
    },
    invoice(data) {
        return Vue.prototype.$http.post(`refresh/invoice`, { data })
    }
}
